/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svr_Guidance_Onsite_7Inputs */

const en_svr_guidance_onsite_7 = /** @type {(inputs: Svr_Guidance_Onsite_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was overtime needed? If so, why?`)
};

const ja_svr_guidance_onsite_7 = /** @type {(inputs: Svr_Guidance_Onsite_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`残業は必要でしたか？もしそうなら、なぜですか？`)
};

const fr_svr_guidance_onsite_7 = /** @type {(inputs: Svr_Guidance_Onsite_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des heures supplémentaires ont-elles été nécessaires ? Si oui, pourquoi ?`)
};

const de_svr_guidance_onsite_7 = /** @type {(inputs: Svr_Guidance_Onsite_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wurden Überstunden benötigt? Wenn ja, warum?`)
};

/**
* | output |
* | --- |
* | "Was overtime needed? If so, why?" |
*
* @param {Svr_Guidance_Onsite_7Inputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const svr_guidance_onsite_7 = /** @type {((inputs?: Svr_Guidance_Onsite_7Inputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svr_Guidance_Onsite_7Inputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_svr_guidance_onsite_7(inputs)
	if (locale === "ja") return ja_svr_guidance_onsite_7(inputs)
	if (locale === "fr") return fr_svr_guidance_onsite_7(inputs)
	return de_svr_guidance_onsite_7(inputs)
});